<template>
  <div class="flex-center">
    <span v-if="text" @click="handleLock">{{ text }}</span>
    <!-- <i v-else
       class="icon-suoping"
       ></i> -->
    <div v-else @click="handleLock" class="flex-center flex-col pointer">
      <img src="@/static/icon_top_lock.png" alt="" style="width: 22px; height: 22px" />
      <span class="color-666 font-12">锁屏</span>
    </div>

    <el-dialog title="设置锁屏密码" :visible.sync="box" width="30%" append-to-body>
      <el-form :model="form" ref="form" label-width="80px">
        <el-form-item
          label="锁屏密码"
          prop="passwd"
          :rules="[{ required: true, message: '锁屏密码不能为空' }]"
        >
          <el-input v-model="form.passwd" placeholder="请输入锁屏密码">
            <el-button slot="append" @click="handleSetLock" icon="el-icon-lock" />
          </el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import { validatenull } from '@/util/validate'
  import { mapGetters } from 'vuex'
  export default {
    name: 'top-lock',
    props: {
      text: String
    },
    data() {
      return {
        box: false,
        form: {
          passwd: ''
        }
      }
    },
    created() {},
    mounted() {},
    computed: {
      ...mapGetters(['lockPasswd'])
    },
    methods: {
      handleSetLock() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.$store.commit('SET_LOCK_PASSWD', this.form.passwd)
            this.handleLock()
          }
        })
      },
      handleLock() {
        if (validatenull(this.lockPasswd)) {
          this.box = true
          return
        }
        this.$store.commit('SET_LOCK')
        setTimeout(() => {
          this.$router.push({ path: '/lock' })
        }, 100)
      }
    },
    components: {}
  }
</script>

<style lang="scss" scoped></style>
